import OrderStaff from '@/models/orderStaff';
import TakeAway from '@/models/takeAway';
import { ActionContext, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { Notice } from '@/interfaces/models/notice';
import noticeApi from '@/api/notice';

type NoticeState = {
  notices: Array<Notice>;
};

const namespaced: boolean = true;

const getDefaultState = (): NoticeState => {
  return {
    notices: []
  };
};

const state: NoticeState = getDefaultState();

const getters: GetterTree<NoticeState, RootState> = {
  unreadNoticeCount(state) {
    return state.notices
      .filter((notice: Notice) => notice.status === 1)
      .length;
  }
};

const actions = {
  clearNotices({ commit }: ActionContext<NoticeState, RootState>) {
    return noticeApi.clearAllNotices()
      .then(() => {
        commit('clearNotices');
      });
  }
};

const mutations: MutationTree<NoticeState> = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setNotices(state, notices: Array<Notice>) {
    state.notices = notices;
  },
  doneOrder(state, id: string) {
    const noticeIndex = state.notices.findIndex(
      (notice: Notice) => notice.entity.id === id
    );

    if (-1 !== noticeIndex) {
      state.notices.splice(noticeIndex, 1);
    }
  },
  takeOrder(state, { id, staff }: any) {
    for (const notice of state.notices) {
      if (notice.entity.id === id) {
        notice.entity.isCooking = true;
        notice.entity.staff = new OrderStaff(staff);
      }
    }
  },
  refuseOrder(state, id: string) {
    for (const notice of state.notices) {
      if (notice.entity.id === id) {
        notice.entity.isCooking = false;
        notice.entity.staff = null;
      }
    }
  },
  createNewOrderNotice(state, notice: Notice) {
    state.notices.push({
      ...notice,
      entity: TakeAway.createFromRequest(notice.entity),
    });
  },
  removeNotice(state, noticeId: string) {
    const noticeIndex = state.notices.findIndex(
      (notice: Notice) => notice.id === noticeId
    );

    if (-1 !== noticeIndex) {
      state.notices.splice(noticeIndex, 1);
    }
  },
  clearNotices(state) {
    state.notices = [];
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
